import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './button.css';

export type ButtonType = {
  to: string;
  onClick?: (e: any) => {};
};

export const Continue = (props: ButtonType) => {
  return (
    <Link to={props.to} className="continue" onClick={props.onClick}>
      Siguiente
    </Link>
  );
};

export const Return = (props: ButtonType) => {
  return (
    <Link to={props.to} className="return">
      Volver atrás
    </Link>
  );
};

Return.propTypes = {
  to: PropTypes.string,
};

Continue.propTypes = {
  to: PropTypes.string,
};
function handleClick(e: any) {
  throw new Error('Function not implemented.');
}
